// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"60402a2c","455":"8119cfb4","977":"7d49a2f1"}[chunkId] + ".chunk.js";
};